import {
  ErrorData,
  Player,
  PlayerStatsAlltimeActionTypes,
  PlayerStatsAlltimeResponse,
  PlayerStatsSeasonActionTypes,
} from 'app/components/team/playerstats/types';
import {GridSortModel} from '@mui/x-data-grid-pro';

export interface PlayerStatsSeasonState {
  isFetching: boolean;
  error: ErrorData;
  players: Player[];
}

export interface PlayerStatsAlltimeState {
  isFetching: boolean;
  error: ErrorData;
  players: PlayerStatsAlltimeResponse | null;
  sortModel: GridSortModel;
}

export interface PlayerStatsState {
  season: PlayerStatsSeasonState;
  alltime: PlayerStatsAlltimeState;
}

export const initialPlayerStatsState: PlayerStatsState = {
  season: {
    isFetching: false,
    players: [],
    error: null,
  },
  alltime: {
    isFetching: false,
    players: null,
    error: null,
    sortModel: [{field: 'matches', sort: 'desc'}],
  },
};

export type Action =
  | {type: PlayerStatsSeasonActionTypes.FETCHING}
  | {type: PlayerStatsSeasonActionTypes.UPDATE; data: Player[]}
  | {type: PlayerStatsSeasonActionTypes.ERROR; errorData: ErrorData}
  | {
      type: PlayerStatsAlltimeActionTypes.UPDATE;
      data: PlayerStatsAlltimeResponse;
    }
  | {
      type: PlayerStatsAlltimeActionTypes.ERROR;
      errorData: ErrorData;
    }
  | {type: PlayerStatsAlltimeActionTypes.FETCHING}
  | {type: PlayerStatsAlltimeActionTypes.ADD; data: PlayerStatsAlltimeResponse}
  | {type: PlayerStatsAlltimeActionTypes.SORTMODEL; data: GridSortModel};

export const TeamPlayerStatsReducer = (state: PlayerStatsState, action: Action): PlayerStatsState => {
  switch (action.type) {
    case PlayerStatsSeasonActionTypes.FETCHING:
      return {...state, season: {...state.season, isFetching: true}};
    case PlayerStatsSeasonActionTypes.UPDATE:
      return {...state, season: {...state.season, players: action.data, isFetching: false}};
    case PlayerStatsSeasonActionTypes.ERROR:
      return {...state, season: {...state.season, error: action.errorData, isFetching: false}};
    case PlayerStatsAlltimeActionTypes.FETCHING:
      return {...state, alltime: {...state.alltime, isFetching: true}};
    case PlayerStatsAlltimeActionTypes.UPDATE:
      return {...state, alltime: {...state.alltime, players: action.data, isFetching: false}};
    case PlayerStatsAlltimeActionTypes.ERROR:
      return {...state, alltime: {...state.alltime, error: action.errorData, isFetching: false}};
    case PlayerStatsAlltimeActionTypes.ADD:
      if (!state.alltime.players) {
        return {...state, alltime: {...state.alltime, players: action.data, isFetching: false}};
      }
      return {
        ...state,
        alltime: {
          ...state.alltime,
          players: {
            data: [...state.alltime.players.data, ...action.data.data],
            meta: action.data.meta,
            links: action.data.links,
          },
          isFetching: false,
        },
      };
    case PlayerStatsAlltimeActionTypes.SORTMODEL:
      return {...state, alltime: {...state.alltime, sortModel: action.data}};
    default:
      return state;
  }
};
